'use strict';
import jwt from 'jsonwebtoken';

export const decoder =
  ({ secret }) =>
  (encoded) =>
    jwt.verify(encoded, secret);
